import { render, staticRenderFns } from "./Species.vue?vue&type=template&id=3d3d0ffb&scoped=true&"
import script from "./Species.vue?vue&type=script&lang=js&"
export * from "./Species.vue?vue&type=script&lang=js&"
import style0 from "./Species.vue?vue&type=style&index=0&id=3d3d0ffb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d3d0ffb",
  null
  
)

export default component.exports